import {
    SET_LOCAL_AGENCY,
} from "./companiesConstants";
import { throwErrorMessage } from '../../lib/error_helper';
import {fetchWithTimeout} from '../../lib/fetch_wrapper';
import { getSiteIds } from "../customerSite/customerSiteActions";

function setLocalAgencyAction(localAgency){
    return {
        type: SET_LOCAL_AGENCY,
        localAgency
    }
}

export function getLocalAgency(userId, allSites, customerSiteId){
    return (dispatch)=>{
        const headers = new Headers({'Content-Type': 'application/json'});
        fetchWithTimeout('/api/v1/companies/get_local_agency/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                userId,
                customerSiteIds: getSiteIds(customerSiteId, allSites),
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((localAgency) => {
                dispatch(setLocalAgencyAction(localAgency));
            }).catch((err) => {
                console.error("Erreur : extranetCompaniesActions - getLocalAgency", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération de l'agence locale",
                }))
            });
    }
}
